import { takeLatest, put, select } from 'redux-saga/effects';
import { PCStoreJsBridge } from '../nativeapi';
import {
  GET_LOCALMACHINEINFO_START,
  GET_LOCALMACHINEINFO_SUCCESS,
  GET_LOCALSOFT_START,
  GET_LOCALSOFT_SUCCESS,
  REQUEST_NATIVE_INSTALL,
  REQUEST_NATIVE_INSTALL_LIST,
  REQUEST_NATIVE_UNINSTALL,
  SILENT_SOFT_INSTALL_INFOS_START,
  SILENT_SOFT_INSTALL_INFOS_SUCCESS,
  PAYGAME_PAY_LIST_REQUEST,
  PAYGAME_PAY_LIST_SUCCESS,
  GET_SUBSCRIBED_APP_LIST,
  SET_SUBSCRIBED_APP_LIST,
} from '../constants/native';
import {
  ANDROID_APP_BATCH_DETAILS,
  SILENT_INSTALL_SOFT_53,
  PAYGAME_PAY_LIST_84,
  SUBSCRIBED_LIST_87,
} from '../config';

import { DOWNLOAD_GET_SOFT_LIST_SUCCESS } from '../constants/downloadTask';
import { createAxios, logNative } from '../utils/utils';
import { cacheKeys } from '../constants/storageKeys';
import dayjs from 'dayjs';

function* fetchLocalMachineInfo() {
  try {
    const result = yield PCStoreJsBridge.getLocalMachineInfo();
    yield put({ type: GET_LOCALMACHINEINFO_SUCCESS, payload: result });
  } catch (error) {
    // throw error;
  }
}

/**
 * 获取本地安装的软件
 * 请求一：首先查询电脑是否打开VT模式true/false
 * false，
 *    请求二：获取PC本地安装列表
 *    请求三：获取PC本地更新列表
 * true
 *    请求二：获取PC本地安装列表
 *    请求三：获取安卓本地安装列表(简洁版)
 *    请求四：获取安卓本地安装列表应用详情并整合
 *    请求五：获取PC安卓本地更新列表
 */
function* fetchLocalSofts() {
  try {
    const axios = yield createAxios();
    const retAnd = [];
    let retPC = [];
    let result = [];

    let vt = localStorage.getItem(cacheKeys.IS_VT_ENABLE);
    if (vt === null) {
      const isVTEnable = yield PCStoreJsBridge.getIsVTEabled();
      vt = isVTEnable.vt ? '1' : '0';
      localStorage.setItem(cacheKeys.IS_VT_ENABLE, vt);
    }

    if (vt === '1') {
      // 获取PC本地安装列表
      retPC = yield PCStoreJsBridge.getLocalInstalledSoft();
      // 获取安卓本地安装列表(简洁版)
      const retA = yield PCStoreJsBridge.getLocalInstalledAndroidSoft();
      const params = [];
      retA.forEach(item => {
        params.push({ packageName: item.pkg, versionCode: item.vc });
      });
      if (params.length > 0) {
        // 获取安卓本地安装列表应用详情并整合
        const retAD = yield axios.post(ANDROID_APP_BATCH_DETAILS, [...params]);
        if (
          retAD.data &&
          retAD.data.status === 0 &&
          retAD.data.data &&
          retAD.data.data.length > 0
        ) {
          retAD.data.data.forEach(item => {
            const find = retA.find(v => v.pkg === item.packageName);
            retAnd.push({
              ...item,
              displayName: item.softName,
              publisher: item.developerName,
              installdate: find.instTime,
              estimateSize: find.size,
            });
          });
        }
      }
      // 获取PC安卓本地更新列表
      yield PCStoreJsBridge.getAndroidPCUpdateSoft();

      result = [...retAnd, ...retPC];
      result.forEach((item, index) => {
        result[index] = {
          ...item,
          sortTime1: new Date(dayjs(`${item.installdate}`).format('YYYY-MM-DD')).getTime(),
        };
      });
      logNative(
        `获取本地列表(安卓、PC) 总耗时: ${+new Date() - window.getUpdateStartTime}, retA: ${
          retA.length
        }, params: ${JSON.stringify(params)}, retAnd: ${retAnd.length}, PC: ${retPC.length}`,
        { retA, retAnd, all: [...retAnd, ...retPC] },
        true,
        true,
      );
    } else {
      // 获取PC本地安装列表
      retPC = yield PCStoreJsBridge.getLocalInstalledSoft();
      // 获取PC本地更新列表
      yield PCStoreJsBridge.getAndroidPCUpdateSoft();

      result = [...retAnd, ...retPC];

      logNative(
        `获取本地列表(PC) 只有PC 总耗时: ${+new Date() -
          window.getUpdateStartTime}, retA: 0, retAnd: 0, PC: ${retPC.length}
          ${JSON.stringify(retPC)}`,
        { retA: [], retAnd, all: [...retAnd, ...retPC] },
        true,
        true,
      );
    }
    result.sort((a, b) => Number(b.installdate) - Number(a.installdate));
    result.forEach((item, index) => {
      result[index] = {
        ...item,
        sortTime1: new Date(dayjs(`${item.installdate}`).format('YYYY-MM-DD')).getTime(),
      };
    });
    yield put({ type: GET_LOCALSOFT_SUCCESS, payload: result });
  } catch (error) {
    logNative(`获取本地列表 fetchLocalSofts ${error}`, error);
  }
}

function* requestNativeUninstall({ soft }) {
  try {
    yield PCStoreJsBridge.uninstallSoft(soft);
  } catch (error) {
    logNative(`卸载应用 requestNativeUninstall 错误 ${error}`, error);
  }
}

/**
 * 获取支持静默安装的应用
 */
function* fetchSilentSoft() {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(SILENT_INSTALL_SOFT_53, { params: {} });

    if (
      res.data.status === 0 &&
      res.data.data &&
      res.data.data.silentIns &&
      res.data.data.silentIns.appInstallInfos &&
      res.data.data.silentIns.appInstallInfos.length > 0
    ) {
      const info = res.data.data.silentIns;
      const supportSilentInstSoft = [];
      info.appInstallInfos.forEach(item => {
        const itemArr = item.split('|');
        supportSilentInstSoft.push({
          softID: itemArr[0],
          silentParamDic: info.disc.silentParamDic[itemArr[1]] || null,
          silentDirParamDic: info.disc.silentDirParamDic[itemArr[2]] || null,
        });
      });
      yield put({
        type: SILENT_SOFT_INSTALL_INFOS_SUCCESS,
        supportSilentInstSoft,
        productRecommendInfo: (res.data.data && res.data.data.productRecommendInfo) || [],
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchLocalMachineInfo() {
  yield takeLatest(GET_LOCALMACHINEINFO_START, fetchLocalMachineInfo);
}

export function* watchFetchLocalSofts() {
  yield takeLatest(GET_LOCALSOFT_START, fetchLocalSofts);
}

export function* watchRequestNativeUninstall() {
  yield takeLatest(REQUEST_NATIVE_UNINSTALL, requestNativeUninstall);
}

export function* watchFetchSilentSoft() {
  yield takeLatest(SILENT_SOFT_INSTALL_INFOS_START, fetchSilentSoft);
}

/**
 * 单机付费，获取已经购买的列表  8.4
 * @param {*} param0
 */
function* fetchPayGanePayList({ param }) {
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(PAYGAME_PAY_LIST_84, { params: param });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: PAYGAME_PAY_LIST_SUCCESS,
        payload: res.data.data || [],
      });
    } else {
      yield put({
        type: PAYGAME_PAY_LIST_SUCCESS,
        payload: [],
      });
    }
  } catch (err) {
    yield put({
      type: PAYGAME_PAY_LIST_SUCCESS,
      payload: [],
    });
  }
}

export function* watchFetchPayGanePayList() {
  yield takeLatest(PAYGAME_PAY_LIST_REQUEST, fetchPayGanePayList);
}

function* fetchSubscribedList({ param }) {
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(SUBSCRIBED_LIST_87);
    if (res?.data?.status === 0) {
      yield put({
        type: SET_SUBSCRIBED_APP_LIST,
        payload: res?.data?.data ?? [],
      });
    }
  } catch (err) {
    yield put({
      type: SET_SUBSCRIBED_APP_LIST,
      payload: [],
    });
    logNative(`获取用户已预约应用失败 ${err}`, err);
  }
}

export function* watchFetchSubscribedList() {
  yield takeLatest(GET_SUBSCRIBED_APP_LIST, fetchSubscribedList);
}
